import type { Absence } from "~/modules/absence/api/absence/absenceTypes.ts";
import { createIcsContent } from "~/modules/absence/utils/absencesViewUtils.ts";

type Params = {
	absence: Absence;
	absenceTypeName: string;
	userEmail: string;
	userFullName: string;
};

export function downloadAbsenceIcs({ absence, absenceTypeName, userEmail, userFullName }: Params) {
	const icsContent = createIcsContent({
		absenceTypeName,
		comment: absence.comment,
		endDate: new Date(absence.endDate),
		firstDayIsHalf: absence.firstDayIsHalf,
		lastDayIsHalf: absence.lastDayIsHalf,
		startDate: new Date(absence.startDate),
		userEmail,
		userFullName,
	});
	const blob = new Blob([icsContent], { type: "text/calendar;charset=utf-8" });
	const url = URL.createObjectURL(blob);
	const link = document.createElement("a");
	link.href = url;
	link.setAttribute("download", `${absence.comment}.ics`);
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	URL.revokeObjectURL(url);
}
